import { BaseServiceService } from './../base-service.service';
import { Injectable } from '@angular/core';
import { BoxAccessUsers } from '../models/BoxAccessUsers';
import { Observable } from 'rxjs';
import { GeneralRegister } from '../models/GeneralRegister';
import { BoxAccessUserPayload } from '../models/BoxAccessUserPayload';

@Injectable({
  providedIn: 'root'
})
export class BoxAccessUserService extends BaseServiceService {
  public setBoxAccessUser(payload: BoxAccessUserPayload): Observable<void> {
    const normalizedId = this.normalizeNonNegativeId(payload.GEN_CONTRATO_CONTROLE_ACESSO ?? 0);
    const normalizedContractId = this.normalizePositiveId(payload.GEN_CONTRATO ?? 0);
    return this.post('client_area/box_access_user', {
      ...payload,
      GEN_CONTRATO_CONTROLE_ACESSO: normalizedId,
      GEN_CONTRATO: normalizedContractId,
      ACESSO_LIBERADO: payload.ACESSO_LIBERADO ? 'S' : 'N',
    }) as Observable<void>;
  }

  public deleteBoxAccessUser(id: number): Observable<void> {
    const normalizedId = this.normalizePositiveId(id);
    return this.delete('client_area/box_access_user/' + normalizedId) as Observable<void>;
  }

  public getDataBoxAccessUser(id: string | number): Observable<BoxAccessUsers> {
    const normalizedId = this.normalizePositiveId(id);
    return this.get('client_area/box_access_user/' + normalizedId) as Observable<BoxAccessUsers>;
  }

  public getCadastroGeral(document: string): Observable<GeneralRegister> {
    return this.get('client_area/search_by_document/' + encodeURIComponent(document.trim())) as Observable<GeneralRegister>;
  }

  private normalizePositiveId(id: string | number): number {
    const normalizedId = this.toInteger(id);
    if (!Number.isInteger(normalizedId) || normalizedId <= 0) {
      throw new Error('Identificador de acesso inválido');
    }

    return normalizedId;
  }

  private normalizeNonNegativeId(id: string | number): number {
    const normalizedId = this.toInteger(id);
    if (!Number.isInteger(normalizedId) || normalizedId < 0) {
      throw new Error('Identificador de acesso inválido');
    }

    return normalizedId;
  }

  private toInteger(id: string | number): number {
    if (typeof id === 'string' && !/^\d+$/.test(id.trim())) {
      return NaN;
    }

    return Number(id);
  }
}
